/* ========= *** GLOBAL VARIABLES *** =========== */
/* selectedProductsData & checkedProductData is Globally initialized in product-details.js for Global use */
/* Selected Product Button */
var finalSelectedProductBtn = $('#grab-selected-products');

/* Grab All Products */
var grabStyleWithProducts = [];
$('.select-product').each(function () {
  grabStyleWithProducts.push({
    variantId: $(this).data('var-id'),
    productId: $(this).data('var-prodid'),
    price: $(this).data('var-price')
  });
});

/* Set Sale Price */
showSalePriceOnSearchBar();

/* ======== Opening Side Drawer ======= */
function openSideDrawer(){
  $(".custom-drawer").addClass('show-custom-drawer');
  $("body").addClass('hidescroll');
  $("body").removeClass('is-rc-close');
  // $("#shopify-section-header, #shopify-section-announcement").addClass('index');
  selectedProductsData && selectedProductsData.length 
    ? finalSelectedProductBtn.text('SELECTED ' + selectedProductsData.length + ' ITEMS')
    : finalSelectedProductBtn.text('SELECTED ITEMS')
  markSelectedProductsChecked()
  checkedProductData = []
  checkedProductData.push(...selectedProductsData);
}

/* ====== Closing Side Drawer ======= */
function closeSideDrawer(){
  $('.products-list').animate({scrollTop: 0}, 800);
  $(".custom-drawer").removeClass('show-custom-drawer');
  $("body").removeClass('hidescroll');
  // $("#shopify-section-header, #shopify-section-announcement").removeClass('index');
}

/* ====== Close drawer on Body Click ====== */
$(".custom-drawer-black").click(function(){
  closeSideDrawer()
});

/* ======= On Click of Image- Select Checkbox ======= */
$(".products-list-img").click(function() {
  $(this).parent().find('.checkbox-wrap').find('.select-product').click();
});

/* ====== Grab Final Selected Products ====== */
function markSelectedProductsChecked(){
  $('.select-product').prop('checked', false);
  selectedProductsData.forEach(function(variantId) {
    var checkbox = $('.select-product[data-var-prodid="' + variantId.pId + '"]');
    checkbox.prop('checked', true);
  });
}

/* ======= Grabbing User's Selected Product Data  ======= 
 *** Push selected data to Array ***
*/
$('.select-product').on('change', function () {
  var variantId = $(this).data('var-id');
  if ($(this).is(':checked')) {
    checkedProductData.push({
      id:    variantId,
      pId:   $(this).data('var-prodid'),
      price: $(this).data('var-price'),
      title: $(this).data('var-title'),
      handle: $(this).data('var-handle'),
      desc:  $(this).data('var-desc'),
      image: $(this).data('var-img'),
      url:   $(this).data('var-url'),
      leadtime: $(this).data('var-leadtime'),
      finalsale: $(this).data('var-finalsale'),
      checkEngraving: $(this).data('var-engraving'),
      checkEngravingPlacement: $(this).data('var-engrave-placement'),
      engravingPlacementOptions: $(this).data('var-engrave-plac-options'),
      engravingStyleOptions: $(this).data('var-engrave-style-options'),
      engravingFonts: $(this).data('var-engraving-fonts'),
      engravingCustomLength: $(this).data('var-custom-length'),
      salePrice: $(this).data('sale-price'),
      vipPrice: $(this).data('vip-price'),
      vvipPrice: $(this).data('vvip-price'),
      compareAtPrice: $(this).data('compare-price'),
      metaFields: $(this).data('meta')
    });
  } else {
    removeProductFromCheckBox(variantId, 'checkbox')
  }
  
  /* ===== Enable/Disable Select Product Button Based on selected product count ====== */
  finalSelectedProductBtn.text((checkedProductData.length === 0) ? 'SELECTED ITEMS' : 'SELECTED ' + checkedProductData.length + ' ITEMS');
});

/* ====== Final Selected Products ======== 
 *** Appending Data to show on PDP Wrapper ***
*/
finalSelectedProductBtn.click(function(e){
  selectedProductsData = [];
  $('.select-product:checked').each(function () {
    var variantId = $(this).data('var-id');
    selectedProductsData.push({
      id: variantId,
      pId:   $(this).data('var-prodid'),
      price: $(this).data('var-price'),
      title: $(this).data('var-title'),
      handle: $(this).data('var-handle'),
      desc:  $(this).data('var-desc'),
      image: $(this).data('var-img'),
      url:   $(this).data('var-url'),
      leadtime: $(this).data('var-leadtime'),
      finalsale: $(this).data('var-finalsale'),
      checkEngraving: $(this).data('var-engraving'),
      checkEngravingPlacement: $(this).data('var-engrave-placement'),
      engravingPlacementOptions: $(this).data('var-engrave-plac-options'),
      engravingStyleOptions: $(this).data('var-engrave-style-options'),
      engravingFonts: $(this).data('var-engraving-fonts'),
      engravingCustomLength: $(this).data('var-custom-length'),
      salePrice: $(this).data('sale-price'),
      vipPrice: $(this).data('vip-price'),
      vvipPrice: $(this).data('vvip-price'),
      compareAtPrice: $(this).data('compare-price'),
      metaFields: $(this).data('meta')
    });
  });
  appendSelectedData()
})

/* ======= Appending Final Selected Data ======= */
function appendSelectedData(){
  /* Appending Final Selected Products to Wrapper */
  var mejuriListWrap = $('.mejuri-list-wrap');
  mejuriListWrap.removeClass('hide')
  /* Empty the complete div */
  mejuriListWrap.empty();
  if (Array.isArray(selectedProductsData) && Array.isArray(grabVariantPrice) && 
      selectedProductsData.length > 0 && grabVariantPrice.length > 0) {

    const productIdsToRemove = selectedProductsData
      .map(item => item.pId)
      .filter(Boolean);

    grabVariantPrice = grabVariantPrice.filter(
      item => !productIdsToRemove.includes(item.productId)
    );
  }
  for (var i = 0; i < selectedProductsData.length; i++) {
    var isEngravingProduct = selectedProductsData[i].checkEngraving
    var isEngravingPlacement = selectedProductsData[i].checkEngravingPlacement
    var engravingPlacementOptionsMejuri = selectedProductsData[i].engravingPlacementOptions
    var engravingStyleOPtionsMejuri = selectedProductsData[i].engravingStyleOptions
    var engravingFonts = selectedProductsData[i].engravingFonts
    var engravingCusLength = selectedProductsData[i].engravingCustomLength
    var metaFieldData = selectedProductsData[i].metaFields
    if (isEngravingProduct && isEngravingProduct === true) {
      $('.ProductForm__AddToCart').off('click');
      var productHTML = generateEngravingProductHTML(selectedProductsData[i],isEngravingProduct,isEngravingPlacement,engravingPlacementOptionsMejuri,engravingStyleOPtionsMejuri,engravingFonts,engravingCusLength);
      mejuriListWrap.append(productHTML);
    } else {
      var productHTML = generateProductHTML(selectedProductsData[i]);
      mejuriListWrap.append(productHTML);
    }
  }
  /* Append Selected Products Calculated Price */
  setCalculatedPrice()
  /* Update Button Text */
  selectedProductsData && selectedProductsData.length ? $('#add-button').text('EDIT') : $('#add-button').text('ADD')
  /* Close Side Drawer */
  closeSideDrawer();
  /* Calling function after HTML gets appended */
  productRemove();
}

/* ======= Raw Product Wrapper HTML: Engraving ======= */
function generateEngravingProductHTML(product, isEngravingProduct, isEngravingPlacement, engravingPlacementOptionsMejuri, engravingStyleOPtionsMejuri,engravingFonts,engravingCusLength) {
  var engravableOptionsArray = [];
  var options = engravingFonts.split(',');
  $.each(options, function(index, value) {
    var option = value.trim();
    if (option !== "") {
      engravableOptionsArray.push(option);
    }
  });

  let html = '<div class="mejuri-list">' +
    '<div class="mejuri-img">' +
    '<img src="' + product.image + '" alt="" />' +
    '</div>' +
    '<div class="mejuri-list-details">' +
    '<div class="title-height">' +
    '<a href="' + product.url + '">' +
    '<h4>' + product.title + '</h4>' +
    '</a>' +
    '</div>';

  if (isEngravingProduct === true) {
    var placementName = "Engravable Placement"
    if (engravingStyleOPtionsMejuri && engravingStyleOPtionsMejuri === true){
      engravablePlacementJson = engravingStyleOptions
      placementName = "Engraving Placement"
    }
    if (engravingPlacementOptionsMejuri && engravingPlacementOptionsMejuri === true){
      engravablePlacementJson = engravingPlacementeOptions
      placementName = "Engraving Placement"
    }
    
    fetchProductByHandle(product.handle, product.metaFields)
    html += '<div class="engraving-product">' +
      '<div class="customflex">' +
      '<div class="Label-details">' +
      '<h4>ENGRAVING (<span class="money">$'+engravingProductPrice+'</span>)</h4>' +
      '<p>Please add an additional 2-3 weeks for engraving.</p>' +
      '</div>' +
      '<div>' +
      '<label class="switch" tabindex="0">' +
      '<input type="checkbox" class="handle-disabled-dropdown" onclick="checkEngravingToggle('+ product.id +')" id="engravablesInputsWrapperMejuri'+product.id+'" autofilled="">' +
      '<span class="slider" id="engravablesInputsWrapperSliderMejuri"></span>' +
      '</label>' +
      '</div>' +
      '</div>' + '<div id="insert-dropdown-' + product.pId + '"></div>';
    
    // Add Engraving Font dropdown HTML
    let engravingOptionsHTML = '<option value="">Select</option>';
    engravableOptionsArray.forEach(option => {
      let fontFamily = "";
      if (option === "Bernhard Tango") {
        fontFamily = "BernhardTangoBT";
      } else if (option === "Celine") {
        fontFamily = "BV Celine";
      } else {
        fontFamily = option.replace(/\s/g, "");
      }
      engravingOptionsHTML += `<option value="${option}" style="font-family: ${fontFamily}; ${option === 'Celine' ? 'text-transform: uppercase;' : ''}">${option}</option>`;
    });
    
    html += `<label class="label-text" for="dropdown2">Font</label>`;
    html += '<div class="dropdown-container">' +
      '<select onchange="setupFontPreview()" id="selected-font-' + product.pId + '" disabled class="dropdown custom-font-selector handle-disabled-dropdown">' +
      engravingOptionsHTML +
      '</select>' +
      '<div class="errormsg hide font-selector-mejuri-error"></div>' +
      '</div>';

    // Add Engraving Placement dropdown HTML
    if (isEngravingPlacement === true) {
      let engravingPlacementOptionsHTML = '<option value="">Select</option>';
      engravablePlacementJson.forEach(option => {
        engravingPlacementOptionsHTML += `<option class="engraving-selected-option" value="${option}">${option}</option>`;
      });
      html += '<label class="label-text" for="dropdown2">'+ placementName +'</label>';
      html += '<div class="dropdown-container">' +
      '<select onchange="setMaxLengthForCustomInputBox('+engravingStyleOPtionsMejuri+')" id="selected-placement-' + product.pId + '" disabled class="dropdown custom-engraving-selector handle-disabled-dropdown">' +
        engravingPlacementOptionsHTML +
      '</select>' +
      '<div class="errormsg hide placement-selector-mejuri-error"></div>' +
      '</div>';
    }

    // Add div for custom input boxes
    html += '<div class="custom-input-boxes">';

    // Add first textbox
    if (engravingPlacementOptionsMejuri === true || engravingStyleOPtionsMejuri === true || engravableOptionsArray.length) {
      if(engravingCusLength && engravingCusLength !== ''){
        html += '<input disabled type="text" onkeyup="inputCharacterCountFont('+product.pId+','+engravingCusLength+')" onkeypress="inputCharacterCountFont('+product.pId+','+engravingCusLength+')" maxlength="'+ engravingCusLength +'" id="mejuriEngravingOne" class="textbox customization-text-box handle-disabled-dropdown mejuri-engraving-text-one-'+product.pId+ '" placeholder="Enter your text here">';
        html += '<span id="character_count_display_one">0/'+ engravingCusLength +'</span>';
      } else {
        html += '<input disabled type="text" maxlength="0" id="mejuriEngravingOne" class="textbox customization-text-box handle-disabled-dropdown mejuri-engraving-text-one-'+product.pId+ '" placeholder="Enter your text here">';
        html += '<span id="character_count_display_one">0/0</span>';
      }
    } else {
      html += '<input disabled type="text" onkeyup="inputCharacterCountEngraving('+product.id+')" onkeypress="inputCharacterCountEngraving('+product.id+')" maxlength="40" id="mejuriEngravingOne" class="textbox customization-text-box handle-disabled-dropdown mejuri-engraving-text-one-'+product.pId+ '" placeholder="Enter your text here">';
      html += '<span id="character_count_display_one">0/40</span>';
    }
    html += '<p id="fontPreviewMejuriOne" class="fontPreviewMejuri"></p>';
    html += '<div class="errormsg hide custom-text-one-mejuri-error"></div>';
    
    // Add second textbox
    html += '<input disabled type="text" id="mejuriEngravingTwo" class="textbox hide customization-text-box handle-disabled-dropdown mejuri-engraving-text-two-'+product.pId+'" placeholder="Enter second line text here">';
    html += '<span class="hide" id="character_count_display_two">0/0</span>';
    html += '<p id="fontPreviewMejuriTwo" class="fontPreviewMejuri"></p>';
    html += '<div class="errormsg hide custom-text-two-mejuri-error"></div>';
    html += '</div>'; // Close custom-input-boxes div
    html += '</div>'; // Close engraving-product div
  }

  html += '<p class="grab-product-leadtime-'+ product.pId +' stack-with-lead-time show-lead-time-add-on-flyout hide">'+ product.leadtime +'</p><a href="javascript:void(0)" class="remove-product" data-var-id=' + product.id + '>Remove</a><a href="javascript:void(0)" class="remove-product-disabled hide">Remove</a>' +
    '</div>' + // Close mejuri-list-details div
    '</div>'; // Close mejuri-list div
  return html;
}

/* ======= Raw Product Wrapper HTML ======= */
function generateProductHTML(product) {
  fetchProductByHandle(product.handle, product.metaFields)
  let html = '<div class="mejuri-list">' +
    '<div class="mejuri-img">' +
    '<img src="' + product.image + '" alt="" />' +
    '</div>' +
    '<div class="mejuri-list-details">' +
    '<div class="title-height-stack-with">' +
    '<a href="' + product.url + '">' +
    '<h4>' + product.title + '</h4>' +
    '</a>' +
    '</div>' +
    '<div id="insert-dropdown-' + product.pId + '">' +
    '</div>';

    html += '<p class="grab-product-leadtime-'+ product.pId +' stack-with-lead-time show-lead-time-add-on-flyout hide">'+ product.leadtime +'</p><a href="javascript:void(0)" class="remove-product" data-var-product-id='+ product.pId +' data-var-id=' + product.id + '>Remove</a><a href="javascript:void(0)" class="remove-product-disabled hide">Remove</a>' +
    '</div>' + // Close stackwith-list-details div
    '</div>'; // Close stackwith-list div
  return html;
}

/* Grabbing Unique Variants Ids and pushing it to Array */
function pushUniqueVariantId(variantId, productId, leadTime) {
  if (leadTime === "Sold Out") {
    return; 
  }
  // Check if an object with the same id already exists in selectedStackVariantIds
  let existingVariant = selectedStackVariantIds.find(item => item.id === variantId);
  if (!existingVariant) {
    selectedStackVariantIds.push({
      id: variantId,
      productid: productId,
      leadtime: leadTime
    })
  }
}

var grabVariantPrice = [];
var previouslySelectedVariantId = null;
/* ======== Insert Selected Product Dropdown Dynamically using product handle ======= */
function fetchProductByHandle(handle, metaFields) {
  fetch(`/products/${handle}.js`)
    .then(response => response.json())
    .then(product => {
      let html = '';
      // Dynamically generate HTML for dropdowns
      product.options.forEach((option, index) => {
        const optionValues = new Set(); // Using a Set to store unique option values
        product.variants.forEach(variant => {
          optionValues.add(variant[`option${index + 1}`]); // Collect unique option values
        });
        html += `
          <div class="product-option" data-metaFields=${JSON.stringify(metaFields)}>
            <label class="label-text" for="option${index + 1}-select">${option.name}:</label>
            <div class="dropdown-container">
              <select class="dropdown custom-dropdown-stack-with customization-text-box-stack-with handle-disabled-dropdown" id="option${index + 1}-select-${product.id}" name="option${index + 1}" data-required="true">
                <option value="">Select</option>
                ${Array.from(optionValues).map(value => `
                  <option value="${value}">${value}</option>
                `).join('')}
              </select>
              <span class="validation-message validation-add-on-products" id="validation-option${index + 1}-${product.id}" style="color: #b00020; display: none;">This field is required.</span>
            </div>
          </div>`;
      });
      document.getElementById('insert-dropdown-' + product.id).innerHTML = html;

      /* Grab details along with Leadtime on variant change */
      product.options.forEach((option, index) => {
        const select = document.getElementById(`option${index + 1}-select-${product.id}`);
        select.addEventListener('change', function () {
          const selectedOptions = {};
          product.options.forEach((option, idx) => {
            selectedOptions[`option${idx + 1}`] = document.getElementById(`option${idx + 1}-select-${product.id}`).value;
          });          
          const variant = findVariantByOptionValues(product.variants, selectedOptions);
          if (variant && variant.id !== previouslySelectedVariantId) {
            previouslySelectedVariantId = variant.id;
            // Update or add the product variant price in grabVariantPrice array
            const existingEntry = grabVariantPrice.find(item => item.productId === product.id);
            if (existingEntry) {
              existingEntry.variantPrice = variant.price;
              existingEntry.productId = product.id;
              existingEntry.metaFields = metaFields;
              existingEntry.variant = variant;
            } else {
              grabVariantPrice.push({
                productId: product.id,
                variantPrice: variant.price,
                metaFields: metaFields,
                variant: variant
              });
            }
          }
          
          if (variant) {
            $('.show-lead-time-add-on-flyout').removeClass('hide')
            $('a.remove-product[data-var-product-id="'+ product.id +'"]').attr('data-var-id', variant.id);
            selectedProductsData.forEach(function(selectedProduct) {
              if (parseInt(selectedProduct.pId) === parseInt(product.id)) {
                var metafieldsForVariant = selectedProduct.metaFields[variant.id];
                selectedProduct.id = variant.id
                selectedProduct.price = variant.price
                selectedProduct.vipPrice = metafieldsForVariant.vip_price_sale_currency?.amount
                selectedProduct.vvipPrice = metafieldsForVariant.vvip_price_sale_currency?.amount
                selectedProduct.salePrice = metafieldsForVariant.custom_sale_price_currency?.amount
              }
            });
            setCalculatedPrice()
            grabLeadTimeStyleWith(variant.id,product.id)
          }
        });
      });

      /* Check Form Data and performing Validation */
      $('.ProductForm__AddToCart').on('click', function (event) {
        validateData(product);
      });
    })
    .catch(error => {
      console.log('product-not-found..........!!')
    });
}

/* ======= Removing Product from HTML and Array ======= */
function productRemove(){
  $('.remove-product').click(function(){
    $('.ProductForm__AddToCart').attr('data-action', 'add-to-cart-with-wishlist')
    removeProductFromCheckBox(parseInt($(this).data('var-id')), 'selectedArray')
    appendSelectedData()
  })
}

/* ======= Data Validation ======= */
function validateData(product){
  const engravingProduct = product.tags.find(item => item === "Engravable");
  if (!engravingProduct) {
    const selectedOptions = {};
    product.options.forEach((option, index) => {
      const select = document.getElementById(`option${index + 1}-select-${product.id}`);
      selectedOptions[`option${index + 1}`] = select?.value;
    });
    /* Grabbing Final Selected Data */
    const variant = findVariantByOptionValues(product.variants, selectedOptions);
    if(variant){
      pushUniqueVariantId(variant.id, product.id, $('.grab-product-leadtime-' + product.id + '').text())
    }
  }
}

/* Function to find variant ID based on selected option values */
function findVariantByOptionValues(variants, selectedOptions) {
  return variants.find(variant => {
    return Object.keys(selectedOptions).every(key => {
      // Remove quotes from both variant and selectedOptions values
      const variantValue = variant[key]?.replace(/"/g, "").replace("\\", "");
      const selectedValue = selectedOptions[key]?.replace(/"/g, "").replace("\\", "");
      return variantValue === selectedValue;
    });
  });
}

/* ====== Append Calculated price of the Selected Products and Variant Prices ====== */
function setCalculatedPrice() {
  // Checking the user is VIP or VVIP for Sale Price
  var checkVisitingCustomer = localStorage.getItem("setVisitingCustomer");
  var calculatedSalePrice = 0;
  var variantCalculatedSalePrice = 0;
  var calculatedCompareAtPrice = 0;
  var showPercentOff = false;
  var enableCompareAtPrice= false;
  if (!selectedProductsData.length) {
    setTimeout(function(){
      $('#calculatePrice').empty();
    },500)
  }
  
  // Filter out items from selectedProductsData if pId matches any productId in grabVariantPrice
  var filteredProductsData = selectedProductsData.filter(product => {
    return !grabVariantPrice.some(variant => variant.productId === product.pId);
  });
  
  // Calculate the total price of the filtered selected products
  var calculatedPrice = filteredProductsData.reduce((sum, product) => {
    return sum + (product.price || 0);
  }, 0);

  /* Sale Price for All Visitors */
  if (showSalePriceGlobal && showSalePriceGlobal === true) {
    // Calculate the total sale price of the filtered selected products
    calculatedSalePrice = filteredProductsData.reduce((sum, product) => {
      return sum + (product.salePrice || 0);
    }, 0);
    showPercentOff = true;
    enableCompareAtPrice = true;
  }
  
  /* Sale Price to show for VIP Visitors */
  if (showVIPPriceGlobal && showVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVIPParam) {
    // Calculate the total VIP sale price of the filtered selected products
    calculatedSalePrice = filteredProductsData.reduce((sum, product) => {
      return sum + (product.vipPrice || 0);
    }, 0);
    showPercentOff = true;
    enableCompareAtPrice = true;
  }

  /* Sale Price to show for VVIP Visitors */
  if (showVVIPPriceGlobal && showVVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVVIPParam) {
    // Calculate the total VVIP sale price of the filtered selected products
    calculatedSalePrice = filteredProductsData.reduce((sum, product) => {
      return sum + (product.vvipPrice || 0);
    }, 0);
    showPercentOff = true;
    enableCompareAtPrice = true;
  }
  
  // Calculate the total Compare at price of the filtered selected products
  calculatedCompareAtPrice = filteredProductsData.reduce((sum, product) => {
    return sum + (product.compareAtPrice || 0);
  }, 0);
  // Calculate the total price of variants
  var variantTotalPrice = grabVariantPrice.reduce(function(sum, item) {
    return sum + item.variantPrice;
  }, 0);

  calculatedCompareAtPrice = grabVariantPrice.reduce(function(sum, item) {
    return sum + item.variant.compare_at_price;
  }, 0);

  /* Sale Price for All Visitors */
  if (showSalePriceGlobal && showSalePriceGlobal === true) {
    // Calculate the total sale price of the filtered selected products
    variantCalculatedSalePrice = grabVariantPrice.reduce(function(sum, item) {
      const customSalePrice = parseFloat(item.metaFields[item.variant.id]?.custom_sale_price_currency.amount, 10) || 0;
      return sum + customSalePrice;
    }, 0);
    showPercentOff = true;
    enableCompareAtPrice = true;
  }
  
  /* Sale Price to show for VIP Visitors */
  if (showVIPPriceGlobal && showVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVIPParam) {
    // Calculate the total VIP sale price of the filtered selected products
    variantCalculatedSalePrice = grabVariantPrice.reduce(function(sum, item) {
      const vipPriceSale = parseFloat(item.metaFields[item.variant.id]?.vip_price_sale_currency.amount) || 0;
      return sum + vipPriceSale;
    }, 0);
    showPercentOff = true;
    enableCompareAtPrice = true;
  }

  /* Sale Price to show for VVIP Visitors */
  if (showVVIPPriceGlobal && showVVIPPriceGlobal === true && checkVisitingCustomer && checkVisitingCustomer === getVVIPParam) {
    // Calculate the total VVIP sale price of the filtered selected products
    variantCalculatedSalePrice = grabVariantPrice.reduce(function(sum, item) {
      const vvipPriceSale = parseFloat(item.metaFields[item.variant.id]?.vvip_price_sale_currency.amount) || 0;
      return sum + vvipPriceSale;
    }, 0);
    showPercentOff = true;
    enableCompareAtPrice = true;
  }
  // Combine both prices
  var totalPrice = calculatedPrice + variantTotalPrice;
  var totalSalePrice = parseFloat(variantCalculatedSalePrice) + parseFloat(calculatedSalePrice);
  // Check if the checkbox is checked, and add $35 (3500 cents) to the total price
  if ($('[id^="engravablesInputsWrapperMejuri"]:checked').length > 0) {
    totalPrice += engravingProductPrice*100; // Add $35 (in cents)
    totalSalePrice += engravingProductPrice; // Add $35
    calculatedCompareAtPrice += engravingProductPrice; // Add $35
  }

  // Format the combined price into a comma-separated dollar amount
  var commaSeparatedPrice = (totalPrice / 100).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  var percentageOff = ''
  var price = totalPrice/100;
  if (showPercentOff == true) {
    percentageOff = (((price - totalSalePrice) / price) * 100).toFixed(2)
    percentageOff = percentageOff.replace(/\.00$/, '') + "% off";
  }
  if (calculatedCompareAtPrice && calculatedCompareAtPrice != null && calculatedCompareAtPrice > 0 && calculatedCompareAtPrice > totalPrice && enableCompareAtPrice == true) {
    percentageOff = (((calculatedCompareAtPrice - price) / calculatedCompareAtPrice) * 100).toFixed(2)
    percentageOff = percentageOff.replace(/\.00$/, '') + "% off";
  }

  // Display the calculated price
  if ((totalSalePrice != '' && totalSalePrice > 0) || (calculatedCompareAtPrice != null && calculatedCompareAtPrice > 0)) {
    if (calculatedCompareAtPrice && calculatedCompareAtPrice > totalPrice) {
      if (parseInt(commaSeparatedPrice) !== 0) {
        if (commaSeparatedPrice.endsWith('.00')) {
          calculatedCompareAtPrice = calculatedCompareAtPrice/100;
          $('#calculatePrice').html(' (+$<span class="comma-price strikeThrough">' + calculatedCompareAtPrice + '</span> <span class="sale-price" style=color:' + salePriceColorGlobal + '>' + '+$' +commaSeparatedPrice.slice(0, -3) + '</span>) ');
        } else {
          calculatedCompareAtPrice = calculatedCompareAtPrice/100;
          $('#calculatePrice').html(' (+$<span class="comma-price strikeThrough">' + calculatedCompareAtPrice + '</span> <span class="sale-price" style=color:' + salePriceColorGlobal + '>' + commaSeparatedPrice + '</span> <span class="percent-off" style=color:' + salePriceColorGlobal + '>' + percentageOff + '</span>) ');
        }
      } else {
        $('#calculatePrice').text('');
      }
    } else {
      if(parseFloat(totalSalePrice) && parseFloat(totalSalePrice) < parseFloat(totalPrice) && showSalePriceGlobal === true){
        if (parseInt(commaSeparatedPrice) !== 0) {
          if (commaSeparatedPrice.endsWith('.00')) {
            totalSalePrice = totalSalePrice.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            totalSalePrice = totalSalePrice.replace(".00","")
            $('#calculatePrice').html(' (+$<span class="comma-price strikeThrough">' + commaSeparatedPrice.slice(0, -3) + '</span> <span class="sale-price" style=color:' + salePriceColorGlobal + '>' + totalSalePrice + '</span> <span class="percent-off" style=color:' + salePriceColorGlobal + '>' + percentageOff + '</span>) ');
          } else {
            $('#calculatePrice').html(' (+$<span class="comma-price strikeThrough">' + commaSeparatedPrice + '</span> <span class="sale-price" style=color:' + salePriceColorGlobal + '>' + totalSalePrice + '</span> <span class="percent-off" style=color:' + salePriceColorGlobal + '>' + percentageOff + '</span>)');
          }
        } else {
          $('#calculatePrice').text('');
        }
      } else {
        totalPrice = totalPrice/100;
        $('#calculatePrice').html(' (+$' + totalPrice + ')');
      }
    }
  } else {
    if (parseInt(commaSeparatedPrice) !== 0) {
      if (commaSeparatedPrice.endsWith('.00')) {
        $('#calculatePrice').text(' (+$' + commaSeparatedPrice.slice(0, -3) + ') ');
      } else {
        $('#calculatePrice').text(' (+$' + commaSeparatedPrice + ') ');
      }
    } else {
      $('#calculatePrice').text('');
    }
  }
}

/* ======= Removing Selected Product from the Array ======= */
function removeProductFromCheckBox(variantId, dataArray){
  if (dataArray === 'checkbox'){
    checkedProductData = checkedProductData.filter(function (product) {
      return product.id !== variantId;
    });
  } else {
    selectedProductsData = selectedProductsData.filter(function (product) {
      return product.id !== variantId;
    });
    grabVariantPrice = grabVariantPrice.filter(function (product) {
      return product.variant.id !== variantId;
    });
  }
}

/* ====== Set Complete Data as Empty and Re-append Blank Wrapper ====== */
function emptyAllSelectedData(){
  /* Empty Data Arrays */
  selectedProductsData = [] 
  checkedProductData = []  
  grabVariantPrice = []
  appendSelectedData()
  $('#calculatePrice').text('')
}

/* ======== Grab Leadtime for all the Products ======== */
async function grabLeadTimeStyleWith(variantId, productId){
  var updatedLeadTime = '';
  if (item) {
    try {
      const response = await fetch(`${portalApiUrl}/mongo/leadtimes?shopifyProductId=${productId}&variantId=${variantId}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        }
      })
      .then(response => response.json())
      .then(function (getResponse) {
        var inventoryQuantity = getResponse.data.availableToSell;
        var inventoryPolicy = getResponse.data.inventory_policy; 
        if (inventoryQuantity !== undefined && inventoryQuantity <= 0) {
            if (inventoryPolicy === "continue") {
            updatedLeadTime = getResponse.data.customLeadTime ? getResponse.data.customLeadTime : '';
          } else {
            updatedLeadTime = "Sold Out";
          }
        } else {
          if (inventoryQuantity !== undefined && inventoryQuantity > 30) {
            updatedLeadTime = "In Stock";
          } else if (inventoryQuantity !== undefined && inventoryQuantity <= 30 && inventoryQuantity > 0) {
            updatedLeadTime = "Only a few left!";
          }
        }
        
        /* Appending Lead Time */
        $('.select-product[data-var-id="' + getResponse.data.id + '"]').attr('data-var-leadtime', updatedLeadTime);
        $(`.grab-product-leadtime-${productId}`).text(updatedLeadTime)
        
        /* Append Final Sale Message */
        if($('.select-product[data-var-id="' + getResponse.data.id + '"]').attr("data-finalsale-message") === true || $('.select-product[data-var-id="' + getResponse.data.id + '"]').attr("data-finalsale-message") === "true"){
          $('.select-product[data-var-id="' + getResponse.data.id + '"]').attr('data-var-finalsale', '(Final Sale!)');
        }
        /* Update selectedProductsData to carry latest leadtime for engraving and cart properties */
        selectedProductsData.forEach(function (item) {
          if (parseInt(item.id) === parseInt(getResponse.data.id)) {
            item.leadtime = updatedLeadTime;
          }
        });
      })
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  }
}

/* ======= Back to Top Button Integration ======= */
var backButtonMejuri = '<a href="#" class="back-to-top" id="topBtn" tabindex="0">Back to Top</a>';
$('.products-list').append(backButtonMejuri);

$('#topBtn').click(function(){
  $('.products-list').animate({scrollTop: 0}, 800);
  return false;
});

/* ======== Engravable Integration with Mejuri ======= */ 
var prevMaxLength = 0;
function checkEngravingToggle(variantId){
  if ($('#engravablesInputsWrapperMejuri'+variantId).is(":checked")) {
    $('.custom-font-selector, .custom-engraving-selector, .customization-text-box').prop('disabled', false);
    $('#mejuriEngravingOne, .custom-font-selector, .custom-engraving-selector').attr('data-required', true);
    if(prevMaxLength !== 0) $('#mejuriEngravingOne').attr('maxlength', prevMaxLength)
    var grabCalculatedPrice = $('#calculatePrice').text();
    var value = parseFloat(grabCalculatedPrice.replace(/[^0-9.]/g, ''));
    var grabCompleteMejuriPrice = (value % 1 === 0) ? value : value.toFixed(2);
    if($('#calculatePrice').find(".comma-price").length !== 0){
      grabCalculatedPrice = $('#calculatePrice').find(".comma-price").text().replace(",", "").replace(".00", "");
      var grabSalePrice = $('#calculatePrice').find(".sale-price").text();
      $('#calculatePrice').find(".comma-price").text((parseFloat(grabCalculatedPrice) + engravingProductPrice).toFixed(2));
      $('#calculatePrice').find(".sale-price").text((parseFloat(grabSalePrice) + engravingProductPrice).toFixed(2));
    } else {
      const price = parseFloat(grabCompleteMejuriPrice) + engravingProductPrice;
      const formattedPrice = price.toLocaleString('en-US', { minimumFractionDigits: price % 1 === 0 ? 0 : 2, maximumFractionDigits: 2 });
      $('#calculatePrice').text(' (+$' + formattedPrice + ')' );
    }
  } else {
    $('.custom-font-selector, .custom-engraving-selector, .customization-text-box').prop('disabled', true).val("")
    $('#character_count_display_one').text('0/0')
    prevMaxLength = $('#mejuriEngravingOne').attr('maxlength')
    $('#mejuriEngravingOne').attr('maxlength','0').removeClass('required')
    $('#fontPreviewMejuriOne, #fontPreviewMejuriTwo').text("")
    $('#mejuriEngravingTwo').addClass('hide').prop("disabled", true).removeClass('required')
    $('#character_count_display_two, .errormsg').addClass('hide')
    $('#mejuriEngravingOne, #mejuriEngravingTwo, .custom-font-selector, .custom-engraving-selector').removeAttr('data-required')
    var grabCalculatedPrice = $('#calculatePrice').text();
    var cleanedPrice = grabCalculatedPrice.replace(/[^0-9.]/g, '');
    var grabCompleteMejuriPrice = (cleanedPrice % 1 === 0) ? parseInt(cleanedPrice) : parseFloat(cleanedPrice);
    if($('#calculatePrice').find(".comma-price").length !== 0){
      grabCalculatedPrice = $('#calculatePrice').find(".comma-price").text();
      var grabSalePrice = $('#calculatePrice').find(".sale-price").text();
      $('#calculatePrice').find(".comma-price").text((parseFloat(grabCalculatedPrice) - engravingProductPrice).toFixed(2));
      $('#calculatePrice').find(".sale-price").text((parseFloat(grabSalePrice) - engravingProductPrice).toFixed(2));
    } else {
      const priceDiff = parseFloat(grabCompleteMejuriPrice) - engravingProductPrice;
      const formattedPrice = priceDiff.toLocaleString('en-US', { minimumFractionDigits: priceDiff % 1 === 0 ? 0 : 2 });
      $('#calculatePrice').text(' (+$' + formattedPrice + ')' );
    }
  }
}

/* ======= Setting Conditions for Max Length & Input Box Along with Font Preview ======= */
function setMaxLengthForCustomInputBox(isEngravingStyle) {
  var trimmedTitle = $('.custom-engraving-selector').val().trim().toLowerCase().replace(/\s/g, "");
  var mejuriEngravingOneBox = $('#mejuriEngravingOne');
  var mejuriEngravingTwoBox = $('#mejuriEngravingTwo');
  var characterCountTwoCounter = $('#character_count_display_two')

  mejuriEngravingOneBox.removeAttr('maxlength').val('')
  mejuriEngravingTwoBox.removeAttr('maxlength').val('')
  $('#fontPreviewMejuriOne, #fontPreviewMejuriTwo').text("")
  $('.errormsg').addClass('hide')

  var maxlengthValueOne, maxlengthValueTwo;
  
  switch (trimmedTitle) {
    case 'rightvertical':
      maxlengthValueOne = 13;
      characterCountTwoCounter.addClass('hide')
      mejuriEngravingOneBox.attr('data-required', true)
      mejuriEngravingTwoBox.addClass('hide').prop('disabled',true).removeAttr('data-required')
      break;
    case 'center-1line':
      maxlengthValueOne = 10;
      characterCountTwoCounter.addClass('hide')
      mejuriEngravingOneBox.attr('data-required', true)
      mejuriEngravingTwoBox.addClass('hide').prop('disabled',true).removeAttr('data-required')
      break;
    case 'center-2lines':
      maxlengthValueOne = 7;
      maxlengthValueTwo = 10;
      characterCountTwoCounter.removeClass('hide')
      mejuriEngravingOneBox.attr('data-required', true)
      mejuriEngravingTwoBox.removeClass('hide').prop('disabled',false).attr('data-required', true)
      break;
    case 'center':
      maxlengthValueOne = 12;
      maxlengthValueTwo = 12;
      characterCountTwoCounter.removeClass('hide')
      mejuriEngravingOneBox.attr('data-required', true)
      mejuriEngravingTwoBox.removeClass('hide').prop('disabled',false).removeAttr('data-required')
      break;  
    case 'bottomright-1line':
      maxlengthValueOne = 4;
      characterCountTwoCounter.addClass('hide')
      mejuriEngravingOneBox.attr('data-required', true)
      mejuriEngravingTwoBox.addClass('hide').prop('disabled',true).removeAttr('data-required')
      break;  
    case 'bottomright-2lines':
      maxlengthValueOne = 2;
      maxlengthValueTwo = 4;
      characterCountTwoCounter.removeClass('hide')
      mejuriEngravingOneBox.attr('data-required', true)
      mejuriEngravingTwoBox.removeClass('hide').prop('disabled',false).attr('data-required', true)
      break;
    default:
      maxlengthValueOne = 10;
      maxlengthValueTwo = 10;
      characterCountTwoCounter.addClass('hide')
      mejuriEngravingOneBox.attr('data-required', true)
      mejuriEngravingTwoBox.addClass('hide').prop('disabled',true).removeAttr('data-required')
      break;
  }
  
  if(trimmedTitle === 'rightvertical' && isEngravingStyle === true) maxlengthValueOne = 12
  
  /* Input Character First */
  $("#character_count_display_one").text("0/" + maxlengthValueOne);
  mejuriEngravingOneBox.attr('maxlength', maxlengthValueOne).off('input').on('input', function() {
    var currentLength = $(this).val().length;
    $('#character_count_display_one').text(currentLength + '/' + maxlengthValueOne);
    /* Font Preview For Text Box One */
    $('#fontPreviewMejuriOne').text($(this).val())
  });
      
  /* Input Character Second */
  $("#character_count_display_two").text("0/" + maxlengthValueTwo);
  mejuriEngravingTwoBox.attr('maxlength', maxlengthValueTwo).off('input').on('input', function() {
    var currentLength = $(this).val().length;
    $('#character_count_display_two').text(currentLength + '/' + maxlengthValueTwo);
    /* Font Preview For Text Box two */
    $('#fontPreviewMejuriTwo').text($(this).val())
  });
}

function inputCharacterCountEngraving(productId){
  var currentLength = $(".mejuri-engraving-text-one-" + productId).val().length;
  $('#character_count_display_one').text(currentLength + '/40');
  /* Font Preview For Text Box One */
  $('#fontPreviewMejuriOne').text($(".mejuri-engraving-text-one-" + productId).val())
}

function inputCharacterCountFont(productId,charCount){
  var currentLength = $(".mejuri-engraving-text-one-" + productId).val().length;
  $('#character_count_display_one').text(currentLength + '/'+charCount);
  /* Font Preview For Text Box One */
  $('#fontPreviewMejuriOne').text($(".mejuri-engraving-text-one-" + productId).val())
}

/* ======= Setup Font Family for Font Preview ======== */
function setupFontPreview() {
  var selectedFontFamily = $('.custom-font-selector').val();
  var selectedFontcase = 'none'
    if (selectedFontFamily === "Celine") {
      selectedFontFamily = "BV Celine";
      selectedFontcase = 'uppercase';
    } else if (selectedFontFamily === "Constane") {
      selectedFontFamily = "Constane"
    } else if (selectedFontFamily === "Bernhard Tango") {
      selectedFontFamily = "BernhardTangoBT"
    } else {
      selectedFontFamily = selectedFontFamily.replace(/\s/g, "");
    }
  $('#fontPreviewMejuriOne').css('font-family',selectedFontFamily).css('text-transform',selectedFontcase)
  $('#fontPreviewMejuriTwo').css('font-family',selectedFontFamily).css('text-transform',selectedFontcase)
}	